import React from 'react'
import * as Styled from './styled'

interface Props {
  id: string
  selected: boolean
  onChange: () => void
  label: string
}

const Checkbox: React.FC<Props> = ({ id, selected, onChange, label, children }) => {
  return (
    <Styled.CheckboxContainer>
      <input
        type="checkbox"
        id={id}
        onChange={onChange}
        checked={selected || false}
        data-test={`${id}-checkbox`}
        aria-label={label}
      />
      {/* eslint-disable-next-line */}
      <label htmlFor={id} />
      {children}
    </Styled.CheckboxContainer>
  )
}

export default Checkbox
